import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRequest } from '../../network';
import {
  loadOrdersSuccess,
  loadOrdersFailed,
  loadOrdersStarted,
  resetOrders,
  STATE_LOADING,
} from '../reducers/clientOrders';

const { REACT_APP_API_URL } = process.env;

const ordersUrl = `${REACT_APP_API_URL}/order`;

const limit = 10;

const useClientOrders = (clientId) => {
  const [hasMore, setHasMore] = useState(true);
  const { get } = useRequest();
  const dispatch = useDispatch();
  const { items, state } = useSelector(({ clientOrders }) => clientOrders);
  const isLoading = state === STATE_LOADING;

  useEffect(() => {
    if (clientId) {
      setHasMore(true);
    }
    // eslint-disable-next-line
  }, [clientId]);

  const start = () => {
    dispatch(loadOrdersStarted());
  };

  const set = (orders) => {
    if (orders.length < limit) {
      setHasMore(false);
    }
    dispatch(loadOrdersSuccess([...items, ...orders]));
  };

  const fail = () => {
    dispatch(loadOrdersFailed());
  };

  const handleError = (error) => {
    console.log(error);
    dispatch(loadOrdersFailed());
  };

  const load = ({ dateFrom, dateTo, userId, clientId, offset }) => {
    start();
    get({
      url: ordersUrl,
      queryParams: {
        ...(dateFrom ? { dateFrom } : {}),
        ...(dateTo ? { dateTo } : {}),
        ...(userId ? { userId } : {}),
        ...(clientId ? { clientId } : {}),
        offset,
        limit,
      },
    })
      .then(set)
      .catch(handleError);
  };

  const reset = () => {
    dispatch(resetOrders());
  };

  return {
    items,
    isLoading,
    start,
    load,
    set,
    fail,
    reset,
    hasMore,
  };
};

export default useClientOrders;
